const Index = () => import(/* webpackChunkName: "web" */ '@/components/web/article/Index');
// const Edit = () => import(/* webpackChunkName: "web" */ '@/components/web/article/Edit');
// const View = () => import(/* webpackChunkName: "web" */ '@/components/web/article/View');

export default {
  routes: [
    {
      path: '/web/article',
      name: 'web_article',
      component: Index
    }
    // , {
    //   path: '/web/article/edit/:dbid?',
    //   name: 'web_article_edit',
    //   component: Edit
    // }, {
    //   path: '/web/article/view/:dbid',
    //   name: 'web_article_view',
    //   component: View
    // }
  ]
}
